<script lang="ts">
	import Icon from "./Icon.svelte";
	import preloader from "../../../core/assets/icons/preloader.svg?raw";
</script>

<div class="flex flex-col items-center justify-center">
	<Icon icon={preloader} class="w-36" />
	<span class="-mt-5 text-2xs">Načítání...</span>
</div>
